import { MONTHS, yearOptions } from "utils/evoTripsUi"
import type { EvoListFilters } from "hooks/usePersistedFilters"
import { EvoButton, EvoFieldLabel, EvoInput, EvoSelect } from "components/evo"

type Props = {
  filters: EvoListFilters
  onChange: (patch: Partial<EvoListFilters>) => void
  onClear?: () => void
  showMonth?: boolean
  showYear?: boolean
  showName?: boolean
}

export const EvoFiltersBar = ({
  filters,
  onChange,
  onClear,
  showMonth = true,
  showYear = true,
  showName = true,
}: Props) => (
  <div className="flex flex-wrap items-end gap-2 lg:gap-3">
    {showName ? (
      <div className="flex min-w-[10rem] flex-col gap-1">
        <EvoFieldLabel>Name</EvoFieldLabel>
        <EvoInput
          type="search"
          placeholder="Filter by name…"
          value={filters.fullName ?? ""}
          onChange={(e) => onChange({ fullName: e.target.value })}
          className="min-w-[140px]"
        />
      </div>
    ) : null}
    {showMonth ? (
      <div className="flex min-w-[8rem] flex-col gap-1">
        <EvoFieldLabel>Month</EvoFieldLabel>
        <EvoSelect
          value={filters.month ?? ""}
          onChange={(e) => onChange({ month: e.target.value })}
          className="min-w-[8rem]"
        >
          <option value="">All months</option>
          {MONTHS.map((m, i) => (
            <option key={m} value={String(i + 1)}>
              {m}
            </option>
          ))}
        </EvoSelect>
      </div>
    ) : null}
    {showYear ? (
      <div className="flex min-w-[7rem] flex-col gap-1">
        <EvoFieldLabel>Year</EvoFieldLabel>
        <EvoSelect
          value={filters.year ?? ""}
          onChange={(e) => onChange({ year: e.target.value })}
          className="min-w-[7rem]"
        >
          <option value="">All years</option>
          {yearOptions().map((y) => (
            <option key={y} value={String(y)}>
              {y}
            </option>
          ))}
        </EvoSelect>
      </div>
    ) : null}
    {onClear ? (
      <EvoButton variant="ghost" size="sm" type="button" onClick={onClear}>
        Clear filters
      </EvoButton>
    ) : null}
  </div>
)
